"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_CART_ITEM_ELECTRICITY = void 0;
const index_1 = require("../../constants/index");
const index_2 = require("../../generated-source/api/index");
const site_address_mock_1 = require("./site-address.mock");
exports.MOCK_CART_ITEM_ELECTRICITY = {
    productDiscounts: [],
    productContent: {
        displayName: 'Electricity_Essentials',
        productConditions: '<p><b>For VIC - HACHN1</b></p>\n<p>test target campaign for VIC&nbsp;</p>\n',
        theme: '#F6A623',
        productInformationLinkText: 'See Energy Fact Sheet',
        planSummary: '/plan-conditions',
    },
    sku: 'AGLMKTRE1220054',
    cartItemId: '3110',
    additionalData: {
        productCategory: index_2.ProductCategory.Energy,
        productQualification: {
            customerType: 'residential',
            fuelType: index_2.FuelTypes.ELECTRICITY,
            requestType: index_1.RequestType.SWITCH,
            siteAddress: site_address_mock_1.MOCK_SITE_ADDRESS,
            hasElectricityWorkSinceLastDisconnection: false,
            electricityLifeSupport: 'No',
        },
        productConfiguration: {
            offerId: '010',
            connectionDate: '2021-12-31',
            partnershipCode: 'partnershipCode',
            webId: 'webId',
        },
        productDisplayAttributes: {
            productName: '',
            infoDoc: '',
            bpidAvailable: true,
            referencePrice: '12%',
            estimatePrice: 1246,
            estimateInfo: 'annual estimate and VDO comparison for using 4000 kWh on a single rate tariff in the CitiPower network',
        },
        rateFactGroup: 'CITIPP',
    },
};
//# sourceMappingURL=cart-item-elec.mock.js.map